import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAsyncActions } from 'react-async-client';

import { fullAutoOptions } from 'constants/asyncClient';
import { getPerson } from 'actions/asyncActions';
import { getFullName } from 'helpers/fieldsHelpers';
import ModalCloseButton from 'components/modals/ModalCloseButton';
import PersonCard from 'components/cards/person/PersonCard';
import CollapsibleModalContainer from '../CollapsibleModalContainer';

@withAsyncActions(({ params: { id } }) => ({
    getPerson: getPerson
        .withParams({ id })
        .withPayload(({ params }) => params.id)
        .withOptions(fullAutoOptions)
}))
export default class PersonModal extends Component {
    static propTypes = {
        params: PropTypes.object.isRequired,
        getPerson: PropTypes.object.isRequired,
        close: PropTypes.func.isRequired,
    };

    render() {
        const { getPerson: { data, meta }, close, params } = this.props;

        const title = meta.success ? meta.success && getFullName(data) : params.value;
        const footer = <ModalCloseButton close={close} />;

        return (
            <CollapsibleModalContainer meta={meta} title={title} footer={footer}>
                <PersonCard person={data} meta={meta} />
            </CollapsibleModalContainer>
        );
    }
}
